import React, {Component} from 'react';
import {connect} from 'react-redux';
import GridGallery from "../../../Helpers/GridGallery/GridGallery";
import UrlPusher from "../../../Helpers/UrlPusher";
import HTML from "../../../Helpers/HTML";
import ReactResizeDetector from 'react-resize-detector';
import { observer } from "mobx-react";

class Image extends Component {
  constructor(props) {
    super(props);
    this.state={
      images:[],
      deleted:0,
      counter:0,
    }
  }
  componentWillMount() {
    let images=[];
    let deleted=0;

    for(let i in this.props.item.images) {
      const cur = this.props.item.images[i];
      if (!cur.deleted) {
        images.push(cur);
      } else {
        deleted++;
      }
    }
    this.setState({
      images:images,
      deleted:deleted,
      counter:images.length
    });

    console.log({
          images:images,
          deleted:deleted,
          counter:images.length
        });
  }
  /*imgLoaded() {
    let cur=this.state.counter;
    cur--;
    this.setState({ counter:cur });
  }*/
  componentDidMount() {
    /*setTimeout(()=>{
      this.props.reScroll();
    },2000);*/
    /*
    this._taCheck = setInterval(() => {
      this.lastHeightSend = 0;
      if (this.lastHeightSend != this._wrapRef.offsetHeight) {
        this.lastHeightSend = this._wrapRef.offsetHeight;
        this.props.reScroll();
      }
      if(this.state.counter === 0) {
        clearInterval(this._taCheck);
        console.log('all loaded clear interval!');
      }
      console.log('fire interval');
    }, 200);
    */
  }
  componentWillUnmount() {
    /*
    if(this._taCheck) {
      clearInterval(this._taCheck);
    }
    */
  }

  render() {

    return (
      <div className="pr" ref={(ref)=>{ this._wrapRef=ref; }} onClick={(e)=>{ e.preventDefault(); e.stopPropagation();  }}>
        <ReactResizeDetector refreshMode={"debounce"} refreshRate={500} handleHeight onResize={()=>{ this.props.reScroll(); }}>
          <div>
            {this.state.images.length?(
              <GridGallery listMode="chat" items={this.state.images} index="property_BIG_PICTURE" />
            ):null}
            {this.state.deleted?(
              <div className="fs11 w5 ptop5">Изображений удалено: {this.state.deleted}</div>
            ):null}
            {this.props.item.message?(
              <div className="ptop4">
                <UrlPusher>
                 <HTML>{this.props.item.message}</HTML>
                </UrlPusher>
              </div>
            ):null}
          </div>
        </ReactResizeDetector>
      </div>
    )
  }
}

/*function mapStateToProps(state) {
  return {}
}*/

export default observer(Image);